import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.17_bufferutil@4.0.9_db0@0.3.2_encoding@0._q4b54onnmrdqmozxybegq2yntu/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}